<template>
    <div v-html="getStars()"></div>
</template>

<script>
    export default {
        props: ['num'],
        methods: {
            getStars () {
                let num = parseInt(this.num)
                let stars = ''
                for (let i = 0; i < num; i++) {
                    stars += '<div class="star"></div>'
                }
                return stars
            }
        }
    }
</script>

<style lang="scss">
    .star {
        width: 18px;
        height: 18px;
        margin: 7px 6px;
        background: url("../assets/images/star-focus@2x.png") no-repeat;
        background-size: cover;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/Star.vue